import React, { useEffect } from 'react';
import config from 'config/config.json';
import GARoute from 'components/GARoute';
import { Event } from 'components/Tracking';
import withRouter from 'helpers/withRouter';

const KNOWN_STATUSES = ['success', 'failure', 'error'];
const SHOP_PRODUCTS_URL = `${config.LUXITY_SHOP_URL}/products/brands`;

const CONTENT = {
  success: {
    title: 'Payment Successful!',
    subtitle: '',
  },
  failure: {
    title: 'Payment Failed',
    subtitle: 'Your payment was cancelled or unsuccessful.',
  },
  error: {
    title: 'Something Went Wrong',
    subtitle: 'We could not process your payment. Please try again.',
  },
};

const HomeLink = () => (
  <GARoute to="/" label="Payment Result: Home" className="payment-result__home">
    Click here to go back to the home page
  </GARoute>
);

const PaymentResultCta = ({ status, saleId }) => {
  if (status === 'success') {
    return (
      <GARoute
        isExternal
        route={SHOP_PRODUCTS_URL}
        label="Payment Result: Continue Shopping"
        className="payment-result__cta">
        Continue Shopping
      </GARoute>
    );
  }

  const tryAgainUrl = saleId ? `/payment/${saleId}` : '/';
  return (
    <GARoute
      to={tryAgainUrl}
      label="Payment Result: Try Again"
      className="payment-result__cta">
      Try Again
    </GARoute>
  );
};

const PaymentResult = ({
  history,
  location: { search },
  params: { status },
}) => {
  const query = new URLSearchParams(search);
  const sale_order_number = query.get('sale_order_number') || '';
  const sale_id = query.get('sale_id') || '';
  const amount = query.get('amount') || '';

  useEffect(() => {
    if (!KNOWN_STATUSES.includes(status)) {
      history.push('/');
      return;
    }
    Event('Payment', status, sale_order_number, parseInt(amount, 10));
  }, [history, status, sale_order_number, amount]);

  if (!KNOWN_STATUSES.includes(status)) return null;

  const content = CONTENT[status];
  return (
    <div className="payment-result">
      <img
        className="payment-result__icon"
        src={`/assets/images/payment-result/${status}.svg`}
        alt={status}
      />
      <h2 className="payment-result__title">{content.title}</h2>
      {content.subtitle && (
        <p className="payment-result__subtitle">{content.subtitle}</p>
      )}
      {status === 'success' && <HomeLink />}
      <PaymentResultCta status={status} saleId={sale_id} />
    </div>
  );
};

export default withRouter(PaymentResult);
